import Vue from 'vue'

function loadSentry() {
  return new Promise((resolve, reject) => {
    if (typeof window.Sentry !== 'undefined') {
      resolve(true);
      return;
    }
    var s;
    s = window.document.createElement('script');
    s.type = 'text/javascript';
    s.src = 'https://browser.sentry-cdn.com/5.4.0/bundle.min.js';
    s.onload = s.onreadystatechange = () => {
      loadVueIntegration().then(() => {
        resolve(false)
      }).catch((error) => {
        reject(error)
      })
    };
    s.onerror = (error) => {
      reject(error)
    }
    window.document.head.appendChild(s);
  })
}

function loadVueIntegration() {
  return new Promise((resolve, reject) => {
    if (typeof window.Sentry.Integrations.Vue !== 'undefined') {
      resolve();
      return;
    }
    var s;
    s = window.document.createElement('script');
    s.type = 'text/javascript';
    s.src = 'https://browser.sentry-cdn.com/5.4.0/vue.min.js';
    s.onload = s.onreadystatechange = () => {
      resolve()
    };
    s.onerror = (error) => {
      reject(error)
    }
    window.document.head.appendChild(s);
  })
}

function initSentry(appConfig, dataset) {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    integrations: [new Sentry.Integrations.Vue({Vue, attachProps: false})]
  })
  Sentry.configureScope((scope) => {
    scope.setExtra('app-config', appConfig);
    scope.setExtra('dataset', dataset)
  });
}

function captureException(error) {
  window.Sentry.captureException(error);
}

export {
  loadSentry,
  initSentry,
  captureException
}
